import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getMallPaypalInfo = payload =>
  httpClient.get(apis.GET_MALL_PAYPAL_INFO + payload.token + '/' + payload.PayerID);
export const getMallPaypalResult = payload =>
  httpClient.get(apis.GET_MALL_PAYPAL_RESULT + payload.token, {
    params: { vendorId: payload.vendorId },
  });
